import triggerRecipientsChanged from '../utils/triggerRecipientsChanged';
import {
    onRequiredAttendeesChanged,
    updateRequiredAttendees,
} from 'owa-calendar-compose-form-actions';
import { orchestrator } from 'satcheljs';
import { RecipientFieldEnum } from 'owa-addins-core';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { prefetchRoomsAvailabilityForRoomPanel } from '../utils/prefetchRoomsAvailabilityForRoomPanel';

export default orchestrator(updateRequiredAttendees, actionMessage => {
    onRequiredAttendeesChanged(actionMessage.requiredAttendees);
    triggerRecipientsChanged(RecipientFieldEnum.RequiredAttendees);

    const { event, originalEvent } = getComposeStore();
    const fullComposeViewState = getFullComposeViewState();

    // if in fullCompose prefetch room availabilities
    if (fullComposeViewState) {
        prefetchRoomsAvailabilityForRoomPanel(
            event.Start,
            event.End,
            event.IsAllDayEvent,
            event.Recurrence,
            actionMessage.requiredAttendees,
            event.OptionalAttendees,
            originalEvent
        );
    }
});
